import React, { useEffect, useState, useCallback } from 'react';
import { FaTrophy, FaMedal, FaAward } from 'react-icons/fa';
import { api } from '../../utils/api';
import { useAuth } from '../../context/AuthContext';
import { safeText } from '../../utils/sanitize';

function formatDate(d) {
  try { return new Date(d).toLocaleDateString(); } catch { return ''; }
}

const RANK_ICONS = {
  1: <FaTrophy />,
  2: <FaMedal />,
  3: <FaAward />,
};

export default function Leaderboard({ refreshTick = 0 }) {
  const { user } = useAuth();
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = useCallback(async () => {
    setLoading(true);
    try {
      const data = await api('/api/scores/leaderboard?game=hextris&limit=10');
      setRows(data);
    } catch {
      setRows([]);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { load(); }, [load, refreshTick]);

  return (
    <aside className="leaderboard glass" aria-label="Leaderboard">
      <div className="leaderboard-head">
        <h3>Leaderboard</h3>
        <button className="btn btn-sm" onClick={load} disabled={loading}>
          {loading ? '...' : 'Refresh'}
        </button>
      </div>
      <ol className="leaderboard-list">
        {rows.length === 0 && !loading && (
          <li className="lb-empty">No scores yet. Be the first.</li>
        )}
        {rows.map((r) => {
          const isMe = user && String(user.id) === String(r.userId);
          const rankClass = r.rank <= 3 ? `lb-top lb-top-${r.rank}` : '';
          return (
            <li
              key={`${r.userId}-${r.rank}`}
              className={`lb-row ${rankClass} ${isMe ? 'lb-me' : ''}`}
            >
              <span className="lb-rank">
                {RANK_ICONS[r.rank] || `#${r.rank}`}
              </span>
              <span className="lb-name">{safeText(r.username)}</span>
              <span className="lb-score">{r.score.toLocaleString()}</span>
              <span className="lb-date">{formatDate(r.createdAt)}</span>
            </li>
          );
        })}
      </ol>
    </aside>
  );
}
